import React from "react";
import PageTemplate from "../../components/PageTemplate";
import ManageWorkspaceMobileHeader from "../../components/Settings/ManageWorkspaceMobileHeader";
import MobileSwitcher from "../../components/MobileSwitcher";
import WorkspaceMobile from "../../components/Settings/workspace/WorkspaceMobile";
import WorkspaceDesktop from "../../components/Settings/workspace/WorkspaceDesktop";

const ManageWorkspace = () => {
  return (
    <PageTemplate
      title="Settings"
      mobileHeader={<ManageWorkspaceMobileHeader />}
      sidebarTitle="Workspace"
      sidebarSubtitle="Manage your workspace, users, roles, etc."
      centered
    >
      <MobileSwitcher
        mobileComponent={<WorkspaceMobile />}
        desktopComponent={<WorkspaceDesktop />}
      />
    </PageTemplate>
  );
};

export default ManageWorkspace;
